<template>
  <nav class="breadcrumb">
    <div v-for="(breadcrumb, index) in breadcrumbs"
         :key="index"
         :class="['breadcrumb-item', {active: breadcrumbs.length && index === breadcrumbs.length - 1}]">
      <a v-if="index + 1 !== breadcrumbs.length" @click="gotoRoute(breadcrumb)">{{breadcrumb ? breadcrumb.title : breadcrumb}}</a>
      <a v-else @click="gotoRoute(breadcrumb)">{{breadcrumb ? breadcrumb.title : breadcrumb}}</a>
    </div>
  </nav>
</template>

<script>
import _ from 'lodash'
// import routes from '@/router/routes'

export default {
  name: 'Breadcrumb',
  props: ['value'],
  data() {
    return {
      breadcrumbs: []
    }
  },
  mounted() {
    if (this.value) {
      this.breadcrumbs = _.cloneDeep(this.value)
    } else if (Array.isArray(this.$store.state.breadcrumbs) && this.$store.state.breadcrumbs.length) {
      this.breadcrumbs = this.$store.state.breadcrumbs
    } else {
      this.breadcrumbs = _.cloneDeep(this.$route.meta.breadcrumbs)
    }
  },
  watch: {
    value: {
      deep: true,
      handler(updatedValue) {
        this.breadcrumbs = Array.isArray(updatedValue) ? _.cloneDeep(updatedValue) : []
      }
    },
    '$store.state.breadcrumbs'(data) {
      this.breadcrumbs = data
    }
  },
  methods: {
    gotoRoute(breadcrumb) {
      if (breadcrumb.path == '/') {
        window.location.href = process.env.VUE_APP_TOP_DOMAIN
      } else if (breadcrumb.path === '/search/menu') {
        if (window.location.pathname === '/search/menu'){
          // 検索結果画面で検索結果のパンくずをクリックしても何もしない
          return;
        }

        // 戻り先画面のURLパラメータが正しいかチェックし再設定
        const previousUrl = JSON.parse(sessionStorage.getItem('previousUrl'))
        const param = {}
        if(!previousUrl){
          param.category = breadcrumb.title === '公共の宿' ? 'publicStay' : 'stay'
        }
        else if(breadcrumb.title === '公共の宿' && previousUrl.category !== 'publicStay'){
          param.category = 'publicStay'
          param.areaLrgClassCd = previousUrl.areaLrgClassCd ?? ''
          param.areaMidClassCd = previousUrl.areaMidClassCd ?? ''
          param.areaSmlClassCd = previousUrl.areaSmlClassCd ?? ''
          param.areaDtlClassCd = previousUrl.areaDtlClassCd ?? ''
          param.keyword = previousUrl.keyword ?? ''
        }
        //↓↓↓ライフエール独自対応↓↓↓
        // breadcrumb.title === '検索結果'
        //↑↑↑ライフエール独自対応↑↑↑
        else if(breadcrumb.title === '検索結果' && previousUrl.category !== 'stay'){
          Object.assign(param, previousUrl)
          param.category = 'stay'
        }
        else{
          Object.assign(param, previousUrl)
        }
        sessionStorage.setItem('previousUrl', JSON.stringify(param))

        // Object.entriesで配列にし、mapで一つ一つの要素を文字列結合し、joinで間に&を入れる
        const pathURL =         
        Object.entries(param)
          .map(([key, value]) => `${key}=${value}`)
          .join('&')
        this.$router.push(`${breadcrumb.path}?${pathURL}`)
      } else if (breadcrumb.path.includes('menus/tour')) {
        // DP検索用の遷移先設定 this.$router.pushでは404になるため処理を変更
        window.location.href = breadcrumb.path
      } else if (breadcrumb.path) {
        if (breadcrumb.query){
          this.$router.push({path: breadcrumb.path, query: breadcrumb.query});
        }else {
          this.$router.push(breadcrumb.path);
        }
        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
